// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"635f5f07","609":"7f685154","691":"f6f9b227"}[chunkId] + ".chunk.js";
};